import React, { useState, useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Header from "./Components/Header";
import NavBar from "./Components/NavBar";
import useAuth from "./useAuth";

export default function AppAuth() {
  const { user } = useAuth();
  const location = useLocation();
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  useEffect(() => {
    setIsMobileNavOpen(false);
  }, [location.pathname]);

  if (!user) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="min-h-screen flex flex-col bg-gray-50 dark:bg-slate-950 text-gray-600 dark:text-slate-300 transition-colors duration-300 relative">
      {/* Mobile Backdrop */}
      {isMobileNavOpen && (
        <div
          onClick={() => setIsMobileNavOpen(false)}
          className="fixed inset-0 bg-slate-900/60 backdrop-blur-xs z-40 lg:hidden transition-opacity duration-300"
        />
      )}

      {/* Sidebar Wrapper */}
      <aside
        className={`fixed top-0 left-0 bottom-0 z-50 w-72 lg:w-64 h-full bg-white dark:bg-slate-900 border-r border-gray-200 dark:border-slate-800 transition-transform duration-300 ease-in-out shadow-2xl lg:shadow-md ${
          isMobileNavOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"
        }`}
      >
        <NavBar onCloseMobile={() => setIsMobileNavOpen(false)} />
      </aside>

      {/* Main Content Area */}
      <div className="lg:ml-64 w-full lg:w-[calc(100%-16rem)] min-h-screen flex flex-col justify-between transition-all duration-300">
        <div className="w-full">
          <div className="sticky top-0 z-30">
            <Header
              isMobileNavOpen={isMobileNavOpen}
              onToggleMobileNav={() => setIsMobileNavOpen((prev) => !prev)}
            />
          </div>
          <main className="p-3 sm:p-4 md:p-6 min-h-[calc(100vh-4rem)] z-10 bg-gray-50 dark:bg-slate-950 text-gray-600 dark:text-slate-300 transition-colors duration-300 overflow-x-hidden">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}

